// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__FaYUQ","titleContainer":"Title_titleContainer__1E_u8","titleWrapper":"Title_titleWrapper__16YD4","title":"Title_title__szi3z"};